import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Button, ButtonType, CloseButtonLabel, ProgressDots } from '../atoms';
import { Dialog } from '../molecules';
import { Colors } from '../styles';
export var MealTaskAboutDialog = function (_a) {
    var onClickSuccess = _a.onClickSuccess, onClickCancel = _a.onClickCancel, classObject = _a.classObject;
    var _b = React.useState(0), pageIndex = _b[0], setPageIndex = _b[1];
    var pages = [
        {
            imageSrc: '/assets/images/dialog/meal_task_about_dialog_effectiveness.jpg',
            title: '食事を記録して\n健康管理しませんか？',
            description: '記録することで食べたものを客観的に管理できます。食事記録でダイエットの効果が2倍になると言われていますよ！',
            buttonText: '次へ',
        },
        {
            imageSrc: '/assets/images/dialog/meal_task_about_dialog_input.jpg',
            title: '食べたものを\nパパッと入力',
            description: '15万件以上の食品から検索できるから食べたものが見つかる！よく食べるものは履歴から素早く入力できます。',
            buttonText: '次へ',
        },
        {
            imageSrc: '/assets/images/dialog/meal_task_about_dialog_score.jpg',
            title: 'スコアとアドバイスを\nチェック！',
            description: '3食入力後は、食事スコアをチェック！1日の食事の評価がひと目でわかります。あなたの食生活を支える味方になります。',
            buttonText: 'さっそく食事管理する！',
        },
    ];
    var isLastPage = function () {
        return pageIndex === pages.length - 1;
    };
    var onClickNext = function () { return (isLastPage() ? onClickSuccess() : setPageIndex(pageIndex + 1)); };
    return (React.createElement(Dialog, { onClickCancel: onClickCancel, isCloseButton: true, closeButtonLabel: CloseButtonLabel.Close, classObject: [styles.dialog, classObject], content: React.createElement(React.Fragment, null,
            React.createElement("img", { className: css(styles.image), src: pages[pageIndex].imageSrc }),
            React.createElement("div", { className: css(styles.info) },
                React.createElement("div", { className: css(styles.title) }, pages[pageIndex].title),
                React.createElement("div", { className: css(styles.description) }, pages[pageIndex].description),
                React.createElement(ProgressDots, { length: pages.length, currentIndex: pageIndex }),
                React.createElement(Button, { className: css(styles.button), isRadius: true, buttonType: ButtonType.pink, onClick: onClickNext }, pages[pageIndex].buttonText))) }));
};
var styles = StyleSheet.create({
    dialog: {
        maxWidth: 327,
        backgroundColor: Colors.White,
    },
    image: {
        width: '100%',
        borderRadius: '8px 8px 0 0',
    },
    info: {
        textAlign: 'center',
        padding: '16px 18.5px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 18,
    },
    title: {
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '140%',
        letterSpacing: 1.6,
        whiteSpace: 'pre-line',
    },
    description: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    button: {
        height: 48,
        padding: 0,
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
});
